export default __webpack_public_path__ + "static/media/lava-ui-lg-2.daae64c0.webp";